import { render, staticRenderFns } from "./ProdutosMaisVendidos.vue?vue&type=template&id=7e29f382&"
import script from "./ProdutosMaisVendidos.vue?vue&type=script&lang=js&"
export * from "./ProdutosMaisVendidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports